import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "./styles/Theme.css";
import Home from "./pages/Home";
import Bio from "./pages/Bio";

const ThemeWrapper = ({ children }) => {
  const location = useLocation();
  const [theme, setTheme] = useState("default");

  useEffect(() => {
    if (location.pathname.startsWith("/bio")) {
      setTheme("bio");
    } else {
      setTheme("default");
    }
  }, [location]);

  return <div className={`theme-wrapper theme-${theme}`}>{children}</div>;
};

const App = () => {
  return (
    <Router>
      <ThemeWrapper>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/bio" element={<Bio />} />
        </Routes>
      </ThemeWrapper>
    </Router>
  );
};

export default App;
